@for (avstemning of avstemninger(); track avstemning.id){
  <avstemning-listevisning [avstemning]="avstemning" [avstemningsstatus]="avstemningsstatus()" [moeteLaastForRedigering]="moeteLaastForRedigering()"/>
}
